<template>
  <el-tabs v-model="activeName">
    <el-tab-pane :label="`SN状态错误(${statusTotal})`" name="first">
      <div style="border-bottom:1px solid #eee;line-height:40px;" v-for="(item, index) in statusData" :key="index">{{item}}</div>
      <el-pagination
        layout="prev, pager, next, total"
        @current-change="statusCurrentChange"
        :page-size="pageSize"
        :current-page="statusCurrent"
        :total="statusTotal">
      </el-pagination>
    </el-tab-pane>
    <el-tab-pane :label="`SN更新失败(${errorTotal})`" name="second">
      <div style="border-bottom:1px solid #eee;line-height:40px;" v-for="(item, index) in errorData" :key="index">{{item}}</div>
      <el-pagination
        layout="prev, pager, next, total"
        @current-change="errorCurrentChange"
        :page-size="pageSize"
        :current-page="errorCurrent"
        :total="errorTotal">
      </el-pagination>
    </el-tab-pane>
    <el-tab-pane :label="`SN重复出货(${repeatTotal})`" name="third">
      <div style="border-bottom:1px solid #eee;line-height:40px;" v-for="(item, index) in repeatData" :key="index">{{item}}</div>
      <el-pagination
        layout="prev, pager, next, total"
        @current-change="repeatCurrentChange"
        :page-size="pageSize"
        :current-page="repeatCurrent"
        :total="repeatTotal">
      </el-pagination>
    </el-tab-pane>
    <el-tab-pane :label="`SN产品线不符(${productModelErrorTotal})`" name="four">
      <div style="border-bottom:1px solid #eee;line-height:40px;" v-for="(item, index) in productModelErrorData" :key="index">{{item}}</div>
      <el-pagination
        layout="prev, pager, next, total"
        @current-change="productModelErrorCurrentChange"
        :page-size="pageSize"
        :current-page="productModelErrorCurrent"
        :total="productModelErrorTotal">
      </el-pagination>
    </el-tab-pane>
    <el-tab-pane :label="`SN不存在(${notExistSnsTotal})`" name="five">
      <div style="border-bottom:1px solid #eee;line-height:40px;" v-for="(item, index) in notExistSnsData" :key="index">{{item}}</div>
      <el-pagination
        layout="prev, pager, next, total"
        @current-change="notExistSnsCurrentChange"
        :page-size="pageSize"
        :current-page="notExistSnsCurrent"
        :total="notExistSnsTotal">
      </el-pagination>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'first',
      statusCurrent: 1,
      errorCurrent: 1,
      repeatCurrent: 1,
      productModelErrorCurrent: 1,
      notExistSnsCurrent: 1,
      pageSize: 10
    };
  },
  props: ['taskImportResult'],
  computed: {
    statusData () {
      if (this.taskImportResult.snStatusErrorSns) {
        let start = (this.statusCurrent - 1) * this.pageSize;
        let end = start + this.pageSize;
        console.log('snStatusErrorSns');
        return this.taskImportResult.snStatusErrorSns.slice(start, end);
      } else {
        return [];
      }
    },
    statusTotal () {
      return this.statusData.length;
    },
    errorData () {
      if (this.taskImportResult.updateFailSns) {
        let start = (this.errorCurrent - 1) * this.pageSize;
        let end = start + this.pageSize;
        console.log('updateFailSns');
        return this.taskImportResult.updateFailSns.slice(start, end);
      } else {
        return [];
      }
    },
    errorTotal () {
      return this.errorData.length;
    },
    repeatData () {
      if (this.taskImportResult.alreadyShipmentFailSns) {
        let start = (this.repeatCurrent - 1) * this.pageSize;
        let end = start + this.pageSize;
        return this.taskImportResult.alreadyShipmentFailSns.slice(start, end);
      } else {
        return [];
      }
    },
    repeatTotal () {
      return this.repeatData.length;
    },
    productModelErrorData () {
      if (this.taskImportResult.productModelErrorSns) {
        let start = (this.productModelErrorCurrent - 1) * this.pageSize;
        let end = start + this.pageSize;
        return this.taskImportResult.productModelErrorSns.slice(start, end);
      } else {
        return [];
      }
    },
    productModelErrorTotal () {
      return this.productModelErrorData.length;
    },
    notExistSnsData () {
      if (this.taskImportResult.notExistSns) {
        let start = (this.notExistSnsCurrent - 1) * this.pageSize;
        let end = start + this.pageSize;
        return this.taskImportResult.notExistSns.slice(start, end);
      } else {
        return [];
      }
    },
    notExistSnsTotal () {
      return this.notExistSnsData.length;
    }
  },
  methods: {
    statusCurrentChange (val) {
      this.statusCurrent = val;
    },
    errorCurrentChange (val) {
      this.errorCurrent = val;
    },
    repeatCurrentChange (val) {
      this.repeatCurrent = val;
    },
    productModelErrorCurrentChange (val) {
      this.productModelErrorCurrent = val;
    },
    notExistSnsCurrentChange (val) {
      this.notExistSnsCurrent = val;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/shipment/child/importResult.vue